import { OBJECT_FIELDS } from "../config/merchantFieldConfig";

export const mapMerchantDetailsToFormValues = (details) => {
  if (!details) return null;

  return {
    merchantName: details.merchantName || "",
    merchantAlias: details.accountAlias || "",
    registrationNumber: details.registrationNumber || "",
    nationality: details.nationality || "",
    address: details.address || "",
    country: details.country || null,
    city: details.city || "",
    county: details.county || "",
    taxPin: details.taxPin || "",
    directors: details.directors || "",
    shareholders: details.shareholders || "",
    merchantType: details.merchantType || null,
    merchantSegment: details.merchantSegment || null,
    currency: details.currency || null,
    registrationDate: details.registrationDate || "",
    email: details.email || "",
    phoneNumber: details.phoneNumber || "",
    economicSector: details.economicSector || null,
    gender: details.gender || null,
    productTransactionCode: details.productTransactionCode || null,
    productOwnership: details.productOwnership || null,
    productCategory: details.productCategory || null,
  };
};

export const mapFormValuesToMerchantPayload = (formValues) => {
  if (!formValues) return null;

  return Object.fromEntries(
    Object.entries(formValues).map(([key, value]) => {
      if (!OBJECT_FIELDS.includes(key) || !value) {
        return [key, value];
      }
      const code = typeof value === "object" ? value.code : value;
      return [key, { code }];
    }),
  );
};

export default {
  mapMerchantDetailsToFormValues,
  mapFormValuesToMerchantPayload,
};
